import { render } from "./VersionCountColumnGraph.vue?vue&type=template&id=ec9cf37c&ts=true"
import script from "./VersionCountColumnGraph.vue?vue&type=script&lang=ts"
export * from "./VersionCountColumnGraph.vue?vue&type=script&lang=ts"

import "./VersionCountColumnGraph.vue?vue&type=style&index=0&id=ec9cf37c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__